module.exports = __webpack_public_path__ + "static/media/8.e7467e6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hairback/8.png
// module id = 688
// module chunks = 0